import React from 'react';
import { Modal, Carousel } from 'react-bootstrap';
import Img from 'gatsby-image';
import { v4 as uuidv4 } from 'uuid';

function LightBox(props) {
	return (
		<Modal {...props} size="md" aria-labelledby="contained-modal-title-vcenter" centered>
			<Carousel>
				{props.images.map((image) => (
					<Carousel.Item key={uuidv4()}>
						<Img fluid={image.localFile.childImageSharp.fluid} />
					</Carousel.Item>
				))}
			</Carousel>
		</Modal>
	);
}

export default LightBox;
